import config from "../../app.json";
import axios from "axios";

import React, { useState, useEffect, useContext } from "react";
import { Context } from "../../Reducers/Store";
import { Row, Col, Button } from "react-bootstrap";
import "./Styles/home.scss";
import FieldText from "../../Components/Fields/FieldText";
import ColorPicker from "../../Components/ColorPicker/ColorPicker";
import FieldUploadMultipart from "../../Components/Fields/FieldUploadMultipart";
import FieldSelect from "../../Components/Fields/FieldSelect";
import AlertComponent from "../../Components/AlertComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFloppyDisk } from "@fortawesome/free-solid-svg-icons";

import SyntaxHighlighter from 'react-syntax-highlighter';
import copy from 'clipboard-copy';
import { shadesOfPurple } from 'react-syntax-highlighter/dist/esm/styles/hljs';


function OnDemandSettings() {
  const [state, dispatch] = useContext(Context);
  const [onDemandWidgetCardColor, setOnDemandWidgetCardColor] = useState(null);
  const [onDemandWidgetTitleColor, setOnDemandWidgetTitleColor] = useState(null);
  const [onDemandWidgetDescriptionColor, setOnDemandWidgetDescriptionColor] = useState(null);
  const [onDemandButtonBackgroundColor, setOnDemandButtonBackgroundColor] = useState(null);
  const [onDemandButtonTextColor, setOnDemandButtonTextColor] = useState(null);
  const [onDemandModalBackgroundColor, setOnDemandModalBackgroundColor] = useState(null);
  const [onDemandModalTitleColor, setOnDemandModalTitleColor] = useState(null);
  const [onDemandModalTextColor, setOnDemandModalTextColor] = useState(null);
  const [onDemandHeaderBackground, setOnDemandHeaderBackground] = useState(null);

  const [onDemandPortalBackgroundColor, setOnDemandPortalBackgroundColor] = useState(null);
  const [onDemandPortalTextColor, setOnDemandPortalTextColor] = useState(null);
  const [onDemandPortalTitleColor, setOnDemandPortalTitleColor] = useState(null);
  const [onDemandWidgetDateColor, setOnDemandWidgetDateColor] = useState(null);

  const [onDemandLogo, setOnDemandLogo] = useState(null);
  const [onDemandThumbnail, setOnDemandThumbnail] = useState(null);
  const [url, setUrl] = useState(null);
  const [data, setData] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadingLogo, setUploadingLogo] = useState(false);
  const [uploadingThumbnail, setUploadingThumbnail] = useState(false);
  const [channels, setChannels] = useState([]);
  const [selectedChannel, setSelectedChannel] = useState(null);
  const [numberPerPage, setNumberPerPage] = useState(10);

  useEffect(() => {
    fetchSettings();
    fetchChannels();
  }, [0]);

  useEffect(() => {
    setOnDemandWidgetCardColor(data?.onDemandWidgetCardColor);
    setOnDemandWidgetTitleColor(data?.onDemandWidgetTitleColor);
    setOnDemandWidgetDescriptionColor(data?.onDemandWidgetDescriptionColor);
    setOnDemandButtonBackgroundColor(data?.onDemandButtonBackgroundColor);
    setOnDemandButtonTextColor(data?.onDemandButtonTextColor);
    setOnDemandModalTitleColor(data?.onDemandModalTitleColor);
    setOnDemandModalTextColor(data?.onDemandModalTextColor);
    setOnDemandHeaderBackground(data?.onDemandHeaderBackground);
    setOnDemandModalBackgroundColor(data?.onDemandModalBackgroundColor);
    setOnDemandLogo(data?.onDemandLogo);
    setOnDemandThumbnail(data?.onDemandThumbnail);
    setOnDemandPortalBackgroundColor(data?.onDemandPortalBackgroundColor);
    setOnDemandPortalTextColor(data?.onDemandPortalTextColor);
    setOnDemandPortalTitleColor(data?.onDemandPortalTitleColor);
    setOnDemandWidgetDateColor(data?.onDemandWidgetDateColor);


    setUrl(data?.url);
  }, [data]);

  const fetchSettings = () => {
    axios.post(config.API + "/api/church/getOnDemandSettings", {
      id: state.church.id
    }).then((res) => {
      if (res?.data?.onDemandLogo)
        res.data.onDemandLogo.preview = config.API + "/api/file/download/?guid=" + res?.data?.onDemandLogo?.guidFile;

      if (res?.data?.onDemandThumbnail)
        res.data.onDemandThumbnail.preview = config.API + "/api/file/download/?guid=" + res?.data?.onDemandThumbnail?.guidFile;

      if (res?.data?.onDemandHeaderBackground)
        res.data.onDemandHeaderBackground.preview = config.API + "/api/file/download/?guid=" + res?.data?.onDemandHeaderBackground?.guidFile;

      setData(res.data);
    }).catch(function (error) {
      return AlertComponent("Error", error?.response?.data?.error || error?.message, { icon: `error` });
    });
  };

  const fetchChannels = () => {
    axios.post(config.API + "/api/channel/getChannelsSelect").then((res) => {
      setChannels(res.data.$values);
    }).catch(function (error) {
      return AlertComponent("Error", error?.response?.data?.error || error?.message, { icon: `error` });
    });
  };

  const handleSave = (e) => {
    e.preventDefault();
    if (uploading || uploadingLogo || uploadingThumbnail)
      return AlertComponent("Error", "You need to wait for the upload to finish before saving.", { icon: `error` });

    axios.post(config.API + "/api/church/updateOnDemandSettings", {
      url,
      onDemandButtonBackgroundColor,
      onDemandButtonTextColor,
      onDemandHeaderBackground,
      onDemandLogo,
      onDemandThumbnail,
      onDemandModalBackgroundColor,
      onDemandModalTextColor,
      onDemandModalTitleColor,
      onDemandWidgetCardColor,
      onDemandWidgetDescriptionColor,
      onDemandWidgetTitleColor,
      onDemandPortalBackgroundColor,
      onDemandPortalTextColor,
      onDemandPortalTitleColor,
      onDemandWidgetDateColor,
      channels: channels?.map(c => { return { id: c.id, friendlyName: c.friendlyName } })
    }).then((res) => {
      return AlertComponent("Success", "On Demand Settings updated successfully!");
    }).catch(function (error) {
      return AlertComponent("Error", error?.response?.data?.error || error?.message, { icon: `error` });
    });
  }

  return (
    <form onSubmit={handleSave}>
      <Row>
        <Col md={11}>
          <h4 className="page-section-title mt-4"></h4>
          <div className="cc-card">
            <Row>
              <Col md="12">
                <h2 className="mb-4">General Customization</h2>
                <Row>
                  <h5>Custom Domain</h5>
                  <Col md="12">
                    <FieldText
                      label="Custom Domain or Subdomain"
                      type="text"
                      onChange={(x) => setUrl(x.target.value)}
                      placeholder="ondemand.yourwebsite.com"
                      value={url}
                      inputClassName={`inputOption`}
                    />
                    <small className="col-md-12">Using your DNS provider, create a CNAME for your Custom Domain that points to <b>partner.churchstreaming.app</b></small>
                  </Col>
                </Row>
                <Row className="mt-4">
                  <h5>Files</h5>
                  <Col md="4">
                    <FieldUploadMultipart
                      onUploadComplete={(u) => setOnDemandHeaderBackground(u)}
                      accept={["image/png", "image/jpg", "image/jpeg", "image/webp"]}
                      label={"Header Image"}
                      maxSize={10 * 1024 * 1024} // 10 MB
                      onStateChanged={setUploading}
                      className="mb-0"
                      data={onDemandHeaderBackground}
                      leftToRight={true}
                    />

                  </Col>
                  <Col md="4">
                    <FieldUploadMultipart
                      onUploadComplete={(u) => setOnDemandLogo(u)}
                      accept={["image/png", "image/jpg", "image/jpeg", "image/webp"]}
                      label={"Page Logo"}
                      maxSize={10 * 1024 * 1024} // 10 MB
                      onStateChanged={setUploadingLogo}
                      className="mb-0"
                      data={onDemandLogo}
                      leftToRight={true}
                    />
                  </Col>
                  <Col md="4">
                    <FieldUploadMultipart
                      onUploadComplete={(u) => setOnDemandThumbnail(u)}
                      accept={["image/png", "image/jpg", "image/jpeg", "image/webp"]}
                      label={"Default Thumbnail"}
                      maxSize={10 * 1024 * 1024} // 10 MB
                      onStateChanged={setUploadingThumbnail}
                      className="mb-0"
                      data={onDemandThumbnail}
                      leftToRight={true}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col md="6 color-setup">
                <h5>Colors</h5>
                <Row>
                  <Col md="3 mb-4">
                    <ColorPicker
                      label="Modal Background"
                      onChange={setOnDemandModalBackgroundColor}
                      color={onDemandModalBackgroundColor}
                      startColor={onDemandModalBackgroundColor || `transparent`}
                    />
                  </Col>
                  <Col md="3 mb-4">
                    <ColorPicker
                      label="Video Title"
                      onChange={setOnDemandModalTitleColor}
                      color={onDemandModalTitleColor}
                      startColor={onDemandModalTitleColor || `transparent`}
                    />
                  </Col>
                  <Col md="3 mb-4">
                    <ColorPicker
                      label="Video Description"
                      onChange={setOnDemandModalTextColor}
                      color={onDemandModalTextColor}
                      startColor={onDemandModalTextColor || `transparent`}
                    />
                  </Col>
                  <Col md="3 mb-4">
                    <ColorPicker
                      label="Button Background"
                      onChange={setOnDemandButtonBackgroundColor}
                      color={onDemandButtonBackgroundColor}
                      startColor={onDemandButtonBackgroundColor || `transparent`}
                    />
                  </Col>

                  <Col md="3 mb-4">
                    <ColorPicker
                      label="Button Text"
                      onChange={setOnDemandButtonTextColor}
                      color={onDemandButtonTextColor}
                      startColor={onDemandButtonTextColor || `transparent`}
                    />
                  </Col>
                  <Col md="3 mb-4">
                    <ColorPicker
                      label="Card Background"
                      onChange={setOnDemandWidgetCardColor}
                      color={onDemandWidgetCardColor}
                      startColor={onDemandWidgetCardColor || `transparent`}
                    />
                  </Col>
                  <Col md="3 mb-4">
                    <ColorPicker
                      label="Card Title"
                      onChange={setOnDemandWidgetTitleColor}
                      color={onDemandWidgetTitleColor}
                      startColor={onDemandWidgetTitleColor || `transparent`}
                    />
                  </Col>
                  <Col md="3 mb-4">
                    <ColorPicker
                      label="Card Description"
                      onChange={setOnDemandWidgetDescriptionColor}
                      color={onDemandWidgetDescriptionColor}
                      startColor={onDemandWidgetDescriptionColor || `transparent`}
                    />
                  </Col>
                  <Col md="3 mb-4">
                    <ColorPicker
                      label="Card Dates"
                      onChange={setOnDemandWidgetDateColor}
                      color={onDemandWidgetDateColor}
                      startColor={onDemandWidgetDateColor || `transparent`}
                    />
                  </Col>

                  <Col md="3 mb-4">
                    <ColorPicker
                      label="Portal Background"
                      onChange={setOnDemandPortalBackgroundColor}
                      color={onDemandPortalBackgroundColor}
                      startColor={onDemandPortalBackgroundColor || `transparent`}
                    />
                  </Col>

                  <Col md="3 mb-4">
                    <ColorPicker
                      label="Portal Text"
                      onChange={setOnDemandPortalTextColor}
                      color={onDemandPortalTextColor}
                      startColor={onDemandPortalTextColor || `transparent`}
                    />
                  </Col>

                  <Col md="3 mb-4">
                    <ColorPicker
                      label="Portal Title"
                      onChange={setOnDemandPortalTitleColor}
                      color={onDemandPortalTitleColor}
                      startColor={onDemandPortalTitleColor || `transparent`}
                    />
                  </Col>
                </Row>
              </Col>
              <Col>
                <h5>Channel Friendly Name</h5>
                <div class="table-responsive" style={{ maxHeight: 546 }}>
                  <table className="table cs-table">
                    <thead>
                      <tr>
                        <th>Channel</th>
                        <th>Friendly Name</th>
                      </tr>

                    </thead>
                    <tbody>
                      {channels?.map((channel, index) => {
                        return (<tr><td>
                          {channel.name}
                        </td>
                          <td>
                            <FieldText
                              type="text"
                              onChange={(e) => {
                                channel.friendlyName = e.target.value;
                                const updatedItems = channels.map((item) => {
                                  if (item.id === channel.id) {
                                    return channel;
                                  }
                                  return item;
                                });
                                setChannels(updatedItems);
                              }}
                              placeholder="Friendly Name"
                              value={channel.friendlyName}
                            />
                          </td>
                        </tr>);
                      })}
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>
            <Row>
              <Col style={{ marginTop: 40, display: 'flex', justifyContent: 'flex-end' }}>
                <Button className="dark-btn" type="submit">
                  Save All Changes
                </Button>
              </Col>
            </Row>
          </div>
          <h4 className="page-section-title mt-4">Generate Widget</h4>
          <div className="cc-card mb-5">
            <Row>
              <Col md="5">
                <h2 className="mb-4">Widget Tool</h2>
                <p>To utilize the widget tool, please follow these steps:</p>

                <ul>
                  <li>Select your desired options.</li>
                  <li>Copy the generated JavaScript code.</li>
                  <li>Locate a suitable container on your website where you want the widget to appear.</li>
                  <li>Paste the copied code inside the chosen container.</li>
                </ul>

                <p>Note: The color customization defined above will also be applied to the widget.</p>

                <p>By completing these steps, the widget will function properly and display on your website as intended. Please note that if you are using the Church Streaming App on-demand page, there is no need to configure this widget.</p>
              </Col>

              <Col md="7">
                <Row>
                  <Col md="5">
                    <FieldText
                      label="Videos per Page (max = 24)"
                      type="number"
                      onChange={(x) => setNumberPerPage(Math.max(1, Math.min(x.target.value.replace(/\D/g, ''), 24)))}
                      value={numberPerPage}
                      className="col-md-12"
                      step={1}
                      min={1}
                      max={24}
                    />
                  </Col>
                  <Col md="5">
                    <FieldSelect
                      label={`Channel to use as the source`}
                      options={channels?.map(c => { return { value: c.id, label: c.name } })}
                      className={`col-md-12`}
                      id={`selectedChannels`}
                      name={`selectedChannels`}
                      onChange={setSelectedChannel}
                      value={selectedChannel}
                      placeholder={`Channel to use as the source`}
                    />
                  </Col>
                  <Col md="2">
                    <Button className="dark-btn" style={{ marginTop: 40 }} onClick={() => {
                      copy(`
<!-- Start Church Streaming Embeded Script -->

<script 
    type="text/javascript"
    data-cs="${config.API}"
    src="${config.API}/js/churchstreaming.js?churchId=${state.church.id}&perPage=${numberPerPage}&channelId=${selectedChannel?.value || ""}">
</script>

<!-- End Church Streaming Embeded Script -->`);
                      return AlertComponent("Success", "Code copied successfully!");
                    }}>
                      Copy
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <SyntaxHighlighter className="code-box" language="cshtml" style={shadesOfPurple} showLineNumbers={true} customStyle={{ height: 300 }}>
                      {` <!-- Start Church Streaming Embeded Script -->

<script 
    type="text/javascript"
    data-cs="${config.API}"
    src="${config.API}/js/churchstreaming.js?churchId=${state.church.id}&perPage=${numberPerPage}&channelId=${selectedChannel?.value || ""}">
</script>

<!-- End Church Streaming Embeded Script -->`}
                    </SyntaxHighlighter>
                  </Col>
                </Row>
              </Col>

            </Row>
          </div>
        </Col>
      </Row>
    </form>
  );
}

export default OnDemandSettings;
